import PercentageValue from "@/components/tableElements/PercentageValue";
import { CurrencyValue } from "@/components/tableElements";
export default {
  name: "PpcBAPrioritizedByCell",
  components: {
    PercentageValue,
    CurrencyValue
  },
  props: {
    value: {
      type: Number
    },
    currency: {
      type: String
    },
    precision: {
      type: String
    },
    type: {
      type: String
    }
  }
};